export default __webpack_public_path__ + "static/media/failed.41ee0edc.svg";